import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { isDesktopMediaQuery } from "../../constants/constants";

interface ModalHOCProps {
    isActive: boolean;
    effect?: "menu-push" | "menu-parallax";
    onClose: () => void;
    disableBackdropClick?: boolean
}

const inPopup = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    const ModalHOC: React.FC<P & ModalHOCProps> = ({
        isActive,
        disableBackdropClick = false,
        effect = "menu-push",
        onClose,
        ...props
    }) => {
        const isDesktop = useMediaQuery(isDesktopMediaQuery);

        const onBackDropClick = () => {
            if(disableBackdropClick) return;
            onClose();
        }

        return (
            <>
                {/* Menu Hider */}
                <div
                    className={`menu-hider ${isActive ? "menu-active" : ""}`}
                    onClick={onBackDropClick}
                ></div>

                {/* Modal Wrapper */}
                <div
                    className={`menu menu-box-modal rounded-m bg-theme ${isActive ? "menu-active" : ""}`}
                    style={{width: '85%'}}
                >
                    {/* Pass down modal-related props */}
                    <WrappedComponent {...(props as P)} onClose={onClose} />
                </div>
            </>
        );
    };

    return ModalHOC;
};

export default inPopup;